var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8035 22.6884L25.4935 25.7854C25.6271 25.8975 25.79 25.9692 25.9631 25.9921C26.1361 26.015 26.3121 25.988 26.4704 25.9144C26.6286 25.8408 26.7625 25.7237 26.8563 25.5767C26.9502 25.4297 27 25.2591 27 25.0848V6.91521C27 6.67248 26.9034 6.43969 26.7315 6.26806C26.5596 6.09642 26.3264 6 26.0833 6H5.91667C5.67355 6 5.44039 6.09642 5.26848 6.26806C5.09658 6.43969 5 6.67248 5 6.91521V21.5585C5 21.8013 5.09658 22.034 5.26848 22.2057C5.44039 22.3773 5.67355 22.4737 5.91667 22.4737H21.2137C21.4295 22.4737 21.6384 22.5497 21.8035 22.6884Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBlack);
export default __webpack_public_path__ + "static/media/chat-black.7b1167cffeb89b3669de398579d4d35a.svg";
export { ForwardRef as ReactComponent };